(function(){
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn){
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function(){
    // ---------- mobile drawer ----------
    var burger = document.getElementById('burgerBtn');
    var drawer = document.getElementById('drawer');
    var backdrop = document.getElementById('drawerBackdrop');
    var drawerClose = document.getElementById('drawerClose');
    function openDrawer(){
      document.body.classList.add('drawer-open');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      if (drawer) drawer.setAttribute('aria-hidden', 'false');
    }
    function closeDrawer(){
      document.body.classList.remove('drawer-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
    }
    if (burger) burger.addEventListener('click', openDrawer);
    if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);
    if (drawer) drawer.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeDrawer); });

    // ---------- cart (real Shopify Ajax Cart API — no localStorage) ----------
    var cartDrawer = document.getElementById('cartDrawer');
    var cartBackdrop = document.getElementById('cartBackdrop');
    var cartClose = document.getElementById('cartClose');
    var cartItemsEl = document.getElementById('cartItems');
    var cartSubtotalEl = document.getElementById('cartSubtotal');
    var cartCountEl = document.getElementById('cartCount');

    function moneyFromCents(cents){
      return '$' + (cents / 100).toFixed(2);
    }
    function escapeHtml(str){
      var div = document.createElement('div');
      div.textContent = str == null ? '' : String(str);
      return div.innerHTML;
    }

    function renderCart(cart){
      if (cartCountEl){
        cartCountEl.textContent = cart.item_count;
        cartCountEl.classList.toggle('is-visible', cart.item_count > 0);
      }
      if (cartSubtotalEl) cartSubtotalEl.textContent = moneyFromCents(cart.total_price);
      if (!cartItemsEl) return;
      if (!cart.items.length){
        cartItemsEl.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
        return;
      }
      cartItemsEl.innerHTML = cart.items.map(function(item){
        return '<div class="cart-line" data-line-key="' + escapeHtml(item.key) + '">' +
          (item.image ? '<img src="' + escapeHtml(item.image) + '&width=128" alt="">' : '') +
          '<div class="cart-line-body">' +
            '<h4>' + escapeHtml(item.product_title) + '</h4>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-line-variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
            '<div class="cart-line-row">' +
              '<div class="cart-qty">' +
                '<button type="button" class="cart-qty-down" aria-label="Decrease quantity">&minus;</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" class="cart-qty-up" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<span class="cart-line-price">' + moneyFromCents(item.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="cart-remove">Remove</button>' +
          '</div>' +
        '</div>';
      }).join('');

      cartItemsEl.querySelectorAll('.cart-line').forEach(function(line){
        var key = line.getAttribute('data-line-key');
        line.querySelector('.cart-qty-up').addEventListener('click', function(){
          var span = line.querySelector('.cart-qty span');
          changeLine(key, parseInt(span.textContent, 10) + 1);
        });
        line.querySelector('.cart-qty-down').addEventListener('click', function(){
          var span = line.querySelector('.cart-qty span');
          var next = parseInt(span.textContent, 10) - 1;
          changeLine(key, next);
        });
        line.querySelector('.cart-remove').addEventListener('click', function(){ changeLine(key, 0); });
      });
    }

    function fetchCart(){
      return fetch('/cart.js', {headers: {'Accept': 'application/json'}}).then(function(r){ return r.json(); });
    }
    function changeLine(key, quantity){
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({id: key, quantity: quantity})
      }).then(function(r){ return r.json(); }).then(renderCart);
    }
    function addToCart(variantId, quantity){
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: variantId, quantity: quantity || 1}]})
      }).then(function(r){
        if (!r.ok) return r.json().then(function(err){ throw err; });
        return fetchCart();
      }).then(function(cart){
        renderCart(cart);
        openCart();
        return cart;
      });
    }
    function openCart(){
      document.body.classList.add('cart-open');
      if (cartDrawer) cartDrawer.setAttribute('aria-hidden', 'false');
    }
    function closeCart(){
      document.body.classList.remove('cart-open');
      if (cartDrawer) cartDrawer.setAttribute('aria-hidden', 'true');
    }
    var cartBtn = document.getElementById('cartBtn');
    if (cartBtn) cartBtn.addEventListener('click', function(e){ e.preventDefault(); openCart(); });
    if (cartClose) cartClose.addEventListener('click', closeCart);
    if (cartBackdrop) cartBackdrop.addEventListener('click', closeCart);
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape'){ closeDrawer(); closeCart(); closeSearch(); } });

    document.addEventListener('click', function(e){
      var btn = e.target.closest('.add-to-cart');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var original = btn.textContent;
      btn.disabled = true;
      addToCart(variantId, 1).catch(function(err){
        alert(err && err.description ? err.description : 'Could not add this item to your cart.');
      }).then(function(){ btn.disabled = false; btn.textContent = original; });
    });

    window.ppAddToCart = addToCart;
    window.ppOpenCart = openCart;

    fetchCart().then(renderCart);

    // ---------- search ----------
    var searchBtn = document.getElementById('searchBtn');
    var searchInput = document.getElementById('searchInput');
    var searchClose = document.getElementById('searchClose');
    var searchStatus = document.getElementById('searchStatus');
    var productCards = document.querySelectorAll('.pick-card[data-product-handle]');

    function openSearch(){
      document.body.classList.add('search-open');
      if (searchBtn) searchBtn.setAttribute('aria-expanded', 'true');
      if (searchInput) searchInput.focus();
    }
    function closeSearch(){
      document.body.classList.remove('search-open');
      if (searchBtn) searchBtn.setAttribute('aria-expanded', 'false');
    }
    function filterVisibleProducts(query){
      if (!productCards.length) return;
      query = (query || '').trim().toLowerCase();
      var visible = 0;
      document.querySelectorAll('.shop-dept').forEach(function(dept){
        var deptHasMatch = false;
        dept.querySelectorAll('.pick-card').forEach(function(card){
          var match = !query || card.textContent.toLowerCase().indexOf(query) !== -1;
          card.style.display = match ? '' : 'none';
          if (match){ deptHasMatch = true; visible++; }
        });
        dept.style.display = deptHasMatch ? '' : 'none';
      });
      if (searchStatus){
        if (query){
          searchStatus.hidden = false;
          searchStatus.textContent = visible === 0
            ? 'No products found for "' + query + '" on this page. Press Enter to search the full catalog.'
            : visible + ' product' + (visible === 1 ? '' : 's') + ' found on this page.';
        } else {
          searchStatus.hidden = true;
        }
      }
    }
    if (searchBtn) searchBtn.addEventListener('click', function(){
      if (document.body.classList.contains('search-open')) closeSearch();
      else openSearch();
    });
    if (searchClose) searchClose.addEventListener('click', function(e){
      e.preventDefault();
      closeSearch();
      if (searchInput) searchInput.value = '';
      filterVisibleProducts('');
    });
    if (searchInput){
      searchInput.addEventListener('input', function(){ filterVisibleProducts(searchInput.value); });
      if (searchInput.value) filterVisibleProducts(searchInput.value);
    }

    // ---------- reveal on scroll ----------
    var els = document.querySelectorAll('[data-reveal]');
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function(el){ el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, {threshold: .18});
      els.forEach(function(el){ io.observe(el); });
    }
  });
})();
